import React from "react";
import { Skeleton } from "antd";

interface IProps {
    even: boolean;
    height?: number;
}

const GroupsListSkeleton: React.FC<IProps> = ({even, height = 60} : IProps) => {
    return (
        <div
            aria-roledescription="groups-list-skeleton"
            className={"groups-list-user-item " + even ? "even" : "odd"}
            role="skeleton"
        >
            <div style={{ width: "100%", padding: "1px 0px", overflowX: "hidden" }}>
                <Skeleton.Input
                    style={{ height: height + "px", verticalAlign: "center" }}
                    active={true}
                    size={"large"}
                    block={true}
                />
            </div>
        </div>
    );
};
export default GroupsListSkeleton;
